/* unplugin-vue-components disabled */import script from "./BoardTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./BoardTable.vue?vue&type=script&lang=ts&setup=true"

import "./BoardTable.vue?vue&type=style&index=0&id=f9c00a46&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9c00a46"]])

export default __exports__